module.exports = __webpack_public_path__ + "img/01.MRO_logotipo-horizontal_principal.ed7d3c0c.png";